import { authActions } from "./auth-slice";
import { uiActions } from "../ui-slice";

export const ValidateToken = (token, id) => {
  return async (dispatch) => {
    const validateInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/validateToken`,
        {
          method: "POST",
          body: JSON.stringify({
            Id: id,
            TokenValidation: {
              Token: token,
              TokenType: "forgotpassword",
            },
            userName: "tokenvalidation@aba.org.do",
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se validar el token");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await validateInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Token validado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo validar el token",
        })
      );
    }
  };
};
export const ForgotPasswordAction = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitud realizada",
        message: "Se esta solicitando el cambio de contraseña",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/forgotpassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo solicitar el cambio de contraseña");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          authActions.setauth({
            usuario: {
              email: response.data.email,
              fullName: response.data.fullName,
            },
          })
        );
        localStorage.setItem("token", response.data.token);
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Solicitud realizada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo solicitar el cambio de contraseña",
        })
      );
    }
  };
};
export const ForgotPasswordInsideAction = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitud realizada",
        message: "Se esta solicitando el cambio de contraseña",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/user/forgotpassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo solicitar el cambio de contraseña");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          authActions.setauth({
            usuario: {
              email: response.data.email,
              fullName: response.data.fullName,
            },
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Solicitud realizada",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo solicitar el cambio de contraseña",
        })
      );
    }
  };
};
export const ChangePasswordAction = (token, authId, password) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando Cambio de contraseña",
        message: "Solicitando Cambio de contraseña al servidor.",
      })
    );
    const validateInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/changepassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: "recoverypassword@aba.org.do",
            id: authId,
            password: password,
            TokenValidation: {
              Token: token,
              TokenType: "forgotpassword",
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo realizar el cambio de contraseña ");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await validateInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "cambio de contraseña completado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el cambio de contraseña",
        })
      );
    }
  };
};

export const ActivePasswordAction = (authId, password) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando Cambio de contraseña",
        message: "Solicitando Cambio de contraseña al servidor.",
      })
    );
    const validateInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/activePassword`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: "recoverypassword@aba.org.do",
            id: authId,
            password: password,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo realizar el cambio de contraseña ");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await validateInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "cambio de contraseña completado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el cambio de contraseña",
        })
      );
    }
  };
};

export const SingIn = (email, password) => {

  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Iniciando Sesión",
        message: "",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/login`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Email: email,
            Password: password,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se realizar el inicio de sesión");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();

      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Bienvenido",
            message: "Inicio de sesión exitoso",
          })
        );
        dispatch(authActions.settoken({ token: response.data.token }));
        localStorage.setItem("token", response.data.token);
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el inicio de sesión",
        })
      );
    }
  };
};

export const VerifyCaptcha = (email, token) => {
  return async (dispatch) => {
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/validateCaptcha`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            CaptchaToken: token,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );

      if (!response.ok) {
        throw new Error("No se realizar el inicio de sesión");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(authActions.setcaptchaVerify({ captchaVerify: true }));
      } else {
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: "No se pudo realizar el inicio de sesión",
          })
        );
        dispatch(authActions.setcaptchaVerify({ captchaVerify: false }));
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el inicio de sesión",
        })
      );
    }
  };
};
export const UpdateDetail = (email, auth) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando datos",
        message: "",
      })
    );
    const loginInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}conference/user/updateDetail`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: auth.id,
            Name: auth.name,
            LastName: auth.lastName,
            CellPhone: auth.cellPhone,
            Country: auth.country,
            Company: auth.company,
            Charge: auth.charge,
            Department: auth.department,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );

      if (!response.ok) {
        throw new Error("No se realizar el inicio de sesión");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await loginInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Dataos actualizados",
            message: "Sus datos han sido actualizados",
          })
        );
        // dispatch(authActions.settoken({ token: response.data.token }));
        localStorage.setItem("token", response.data.token);
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar los datos",
        })
      );
    }
  };
};

export const CleanUser = () => {
  return async (dispatch) => {
    try {
      dispatch(
        authActions.setauth({
          auth: {
            email: "",
            name: "",
            lastName: "",
            identification: "",
            cellPhone: "",
            country: "",
            city: "",
            address: "",
            company: "",
            charge: {},
            department: {},
            status: false,
            token: "",
            fullName: "",
          },
        })
      );
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          // message: "No se pudo obtener la persona",
        })
      );
    }
  };
};

export const GetUserByemail = (email, userName, auths, dontShow) => {
  return async (dispatch) => {
    if (dontShow === undefined) {
    }
    const getUsuarioInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}admin/user/getByEmail`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: userName,
            Email: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la persona");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getUsuarioInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          authActions.setauth({
            auth: response.data,
            auths: auths,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          authActions.setauth({
            auth: {},
            auths: auths,
          })
        );
        if (dontShow === undefined) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la persona",
        })
      );
    }
  };
};
